export const backdropBlurFilter = (blurValue, backgroundColor, opacity, fallbackOpacity) => `
      backdrop-filter: blur(${blurValue.toString()}px);
      position: relative;
      &:before {
          content: '';
          background: rgba(${backgroundColor}, ${opacity.toString()});
          position: absolute;
          left:0;
          top:0;
          width:100%;
          height:100%;
      }
      @-moz-document url-prefix() {
          &:before {
              background: rgba(${backgroundColor}, ${(fallbackOpacity || opacity).toString()});
          }
      }
  `;
